<template>
    <div id="card" class="qb-padding" style="min-height: 312px;">
        <vue-element-loading :active="this.show"/>
            
            <v-select v-model="selected" v-if=" vendedor && options.length > 0" :options="options" :value="$store.myValue" @input="SetPagamento" style="margin-top:10px;min-width:300px;max-width:300px;display:inline-block;">
            </v-select>
            <p style="display:inline-block;margin-left:10px;color:silver;" v-if="vendedor">DESCONTO MÁXIMO: {{percent}}%</p><br>
            
            <textarea v-if="order" placeholder="Escreva uma observação" rows="5" cols="35" v-model="order.observation">
            </textarea><br>
            
            <button v-if="order" class="btn btn-primary btn-add-comment" style="margin-top:0 !important;" @click="Comentar()">
                {{(order.observation ? 'Salvar Observação':'Adicionar Observação')}}
            </button> 
        <div style="display: flex; align-items: center; justify-content: space-between" v-scroll="handleScroll">
            <!-- <button class="btn btn-primary" @click="Conclude" style="width: 150px;height: 40px;display: flex;align-items: center;justify-content: space-between; order: 2">
                Fechar pedido<TruckDelivery class="md-28 white"/>
            </button> -->
            <button class="btn btn-primary" @click="generatePdf" style="width: 200px;height: 50px;align-items: center;padding:10px;border-radius:5px;">
                EXPORTAR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </button>
            <button class="btn btn-primary" @click="Conclude" style="width: 200px;height: 50px;align-items: center;padding:10px;border-radius:5px;">
                FECHAR PEDIDO&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<TruckDelivery class="md-28 white"/>
            </button>
            <button class="btn btn-primary qb-shadow-1" v-if="exibirBotao" @click="Conclude" style="position: fixed; width: 150px; height: 40px; right: 15px; bottom: 55px;display: flex;align-items: center;justify-content: space-between;">
                <span>Fechar pedido {{ priceFormater(total) }}</span><TruckDelivery style="margin-right: 2px;" class="md-28 white"/>
            </button>
            <!-- <p class="qb-txt-xl qb-txt-color-price qb-txt-bold">Total {{ priceFormater(total) }} </p> -->
        </div>
    <table>
        <thead>
            <tr>
                <!-- <th>#</th>
                <th @click="ordernarIndice()">Código</th> -->
                <th colspan="2">Produto</th>
                <th>qtde</th>
                <!-- <th >Descrição</th> -->
                <!-- <th>Embalagem</th> -->
                <!-- <th>Peças p/ Caixa</th> -->
                <th>vlr Lojista</th>
                <!--<th>vlr Sugerido</th>-->
                <!-- <th>Desconto</th> -->
                <th v-if="vendedor">Desconto</th>
                <th v-if="vendedor">Acréscimo</th>
                <th>Total</th>
                <th></th>
                <th></th>
            </tr>
        </thead>
        <transition-group name="slide" tag="tbody" mode="out-in" >
            <tr v-for="(produto, index) in produtos" :key="produto.productId">
                <!-- <td data-label="#">{{ index + 1}}</td>
                <td data-label="Código">{{ produto.productId }}</td> -->
                <td data-label="produto">
                    <!-- <carousel :autoplay="false" :nav="false" :items="1" v-if="produto.images.length">
                        <img v-for="(imagem, index) in produto.images" :key="index" :src="imagem" alt="foto produto" style="max-width: 100%;max-height: 80px;min-height: 80px;"/>
                    </carousel>
                    <img v-else src="@/assets/sem-foto.png" alt="foto produto" style="max-width: 100%;max-height: 80px;min-height: 80px;"/> -->
                    <img v-if="produto.images.length" :src="produto.images[0]" style="max-width: 100%;max-height: 80px;min-height: 80px;" alt="foto produto"/> 
                    <img v-else src="@/assets/sem-foto.png" alt="foto produto" />
                </td>
                <td data-label="Descrição">
                    {{ formatarDescricao(produto.description) }}<br />
                    REF {{ produto.productId }}
                </td>
                <td data-label="Quantidade" >
                    <InputCarrinho :produto="produto" @atualizaTotal="TotalPedido()"/>
                </td>
                <!-- <td data-label="Embalagem">N/A</td> -->
                <!-- <td data-label="Peças p/ Caixa">N/A</td> -->
                <td data-label="valor Lojista">{{ priceFormater( 
                        (produto.percentageDiscountVendedor != 0 
                        ? ( produto.unitaryPrice - (produto.unitaryPrice * produto.percentageDiscountVendedor) / 100 )
                        : ( produto.PercentageAdd != 0 
                            ?  ( produto.unitaryPrice + (produto.unitaryPrice * produto.percentageAdd) / 100 )
                            :  produto.discountPrice
                            )
                        ) 
                    ) }}</td>
                <!--<td data-label="valor Sugerido">{{priceFormater(
                    ( produto.percentageDiscountVendedor != 0 
                    ? produto.unitaryPrice + (produto.unitaryPrice - (produto.unitaryPrice * produto.percentageDiscountVendedor) / 100 ) * 0.15
                    : ( produto.percentageAdd != 0 
                        ?  produto.unitaryPrice + (produto.unitaryPrice + (produto.unitaryPrice * produto.percentageAdd) / 100 ) * 0.15
                        : produto.unitaryPrice + (produto.unitaryPrice * 0.15) )
                    )
                    ) }}</td>-->
                <!-- <td data-label="Desconto Floresta">{{ produto.percentageDiscount }}</td> -->

                <td data-label="Desconto" v-if="vendedor">
                    <InputDesconto :produto="produto" @atualizaTotalDesconto="TotalPedido()"/>              
                </td>
                <td data-label="Acréscimo" v-if="vendedor">
                    <InputAcrescimo :produto="produto" @atualizaTotalAcrescimo="TotalPedido()"/>              
                </td>
                <td data-label="Total" class="TotalProduto">{{ priceFormater( 
                        ( produto.percentageAdd != 0 
                        ? (produto.unitaryPrice + (produto.unitaryPrice * produto.percentageAdd) / 100 ) * produto.quantity 
                        :(produto.unitaryPrice - (produto.unitaryPrice * produto.percentageDiscountVendedor) / 100 ) * produto.quantity 
                        )
                    )}}
                </td>
                <td data-label=""><div class="acoes" @click="remove(produto,index)"><Close /></div></td>
                <td  v-if="percent < produto.percentageDiscountVendedor" style="padding:0;">
                    {{produto.percentageDiscountVendedor=percent}}
                    {{alterado[index]=true}}                    
                </td>
                <td v-if="percent > produto.percentageDiscountVendedor" hidden>
                    <p style="display:none;">{{alterado[index]=false}}</p>
                </td>
                <td v-if="alterado[index]">
                    <Alert style="color:orange;font-size:20px;"/>
                </td>
                <td v-else></td>
            </tr>   
        </transition-group>
        <tr style="font-weight:bold;">
            <td colspan="2">{{produtos.length}} PRODUTOS</td>
            <td data-label="QUANTIDADE GERAL">{{qtd_total}}</td>
            <td data-label="VALOR LOJISTA">{{priceFormater( this.total_lojista )}}</td>
            <!--<td data-label="VALOR SUGERIDO">{{priceFormater( this.total_sugerido )}}</td>-->
            <td v-if="vendedor"></td>
            <td v-if="vendedor"></td>
            <!-- <th>LUCRO {{priceFormater( this.total_sugerido - this.total_lojista )}}</th> -->
            <td data-label="TOTAL">{{ priceFormater(total) }}</td>
            <td></td>
            <!-- <th></th> -->
        </tr>
        <!-- <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>TOTAL LOJISTA {{priceFormater( this.total_lojista )}}</td>
        <td>TOTAL SUGERIDO {{priceFormater( this.total_sugerido )}}</td>
        <td>LUCRO {{priceFormater( this.total_sugerido - this.total_lojista )}}</td>
        <td></td>
        <td></td>
        <td></td> -->
    </table>
    <transition name="slide" mode="out-in" >
        <p v-if="this.total == 0">sem itens no carrinho</p>
    </transition>
     <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="export"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="100%"
        html-to-pdf-options="{margin: 20, filename: 'export.pdf'}"

        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
    >
        <section slot="pdf-content">
            <div class="div-pdf">
            <img width="200" src="@/assets/logo-florestapreto.png" alt="foto produto" />
            <h3>{{nome_cli}}</h3>
            <h3>{{pag_forma_desc}}</h3>
            <table class="table-pdf">
                <thead>
                    <tr>
                        <th>Produto</th>
                        <th>qtde</th>
                        <th>vlr Lojista</th>
                        <th v-if="vendedor">Desconto</th>
                        <th>Total</th>
                    </tr>
                </thead>
                    <tr v-for="(produto, index) in produtos" :key="produto.productId">
                        <td data-label="Descrição">
                            {{ formatarDescricao(produto.description) }}<br />
                            REF {{ produto.productId }}
                        </td>
                        <td data-label="Quantidade" >
                            <span>{{produto.quantity}}</span>
                        </td>
                        <td data-label="valor Lojista">{{ priceFormater( 
                                (produto.percentageDiscountVendedor != 0 
                                ? ( produto.unitaryPrice - (produto.unitaryPrice * produto.percentageDiscountVendedor) / 100 )
                                : ( produto.PercentageAdd != 0 
                                    ?  ( produto.unitaryPrice + (produto.unitaryPrice * produto.percentageAdd) / 100 )
                                    :  produto.discountPrice
                                    )
                                ) 
                            ) }}</td>
                        <td data-label="Desconto" v-if="vendedor">
                            <span>{{produto.percentageDiscountVendedor}}</span>              
                        </td>
                        <td data-label="Total" class="TotalProduto">{{ priceFormater( 
                                ( produto.percentageAdd != 0 
                                ? (produto.unitaryPrice + (produto.unitaryPrice * produto.percentageAdd) / 100 ) * produto.quantity 
                                :(produto.unitaryPrice - (produto.unitaryPrice * produto.percentageDiscountVendedor) / 100 ) * produto.quantity 
                                )
                            )}}
                        </td>
                    </tr>  
                <tr style="font-weight:bold;">
                    <td>{{produtos.length}} PRODUTOS</td>
                    <td data-label="QUANTIDADE GERAL">{{qtd_total}}</td>
                    <td data-label="VALOR LOJISTA">{{priceFormater( this.total_lojista )}}</td>
                    <td v-if="vendedor"></td>
                    <td data-label="TOTAL">{{ priceFormater(total) }}</td>
                </tr>
            </table>
            </div>
        </section>
    </vue-html2pdf>
   </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import { userKey } from "@/global";
// import Imagem from "./imagem.vue";
import InputCarrinho from "./input-carrinho.vue";
import InputDesconto from "./input-desconto.vue";
import InputAcrescimo from "./input-acrescimo.vue";
import Close from "vue-material-design-icons/Close.vue";
import Pencil from "vue-material-design-icons/Pencil.vue";
import Plus from "vue-material-design-icons/Plus.vue";

import Alert from "vue-material-design-icons/Alert.vue";

import TruckDelivery from "vue-material-design-icons/TruckDelivery.vue";
import VueElementLoading from 'vue-element-loading';
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import VueHtml2pdf from 'vue-html2pdf';

// import { FadeTransition   } from 'vue2-transitions';

export default {
    components:{
        // Imagem,
        TruckDelivery,
        VueElementLoading,
        Alert,
        // FadeTransition,
        InputCarrinho,
        InputDesconto,
        InputAcrescimo,
        Close,
        Pencil,
        Plus,
        vSelect,
        VueHtml2pdf
    },
    props:['adiciona' ],
    mounted(){
        axios.get(`${baseApiUrl}/orders/cart` + (this.cliente ? `/?clienteID=${this.cliente}` : '') )
        .then(res => {
            this.produtos = res.data;
            this.TotalPedido();
            this.show=false;
            
            axios.get(`${baseApiUrl}/orders/comment/?orderId=${res.data[0].orderId}`)
            .then(res => {
                this.order = res.data.order;     
            })
        })     
    },
    data(){
        return{
            produtos:[],
            alterado: [],
            forma_pagamento_alterado:'',
            total: 0,
            vendedorID:0,
            qtd_total:0,
            esconder: true,
            ordenado: false,
            order : [],
            total_lojista: 0,
            total_sugerido: 0,
            exibirBotao: false,
            percent: 0,
            nome_cli: '',
            pag_forma_desc: '',
            cliente: '',
            pagtoId: 0,
            vendedor: false,
            show:true,
            atualizandoQuantidadeProduto: false,
            pagamento: 0,
            selected: {label:'Selecione uma Forma de Pagamento', id:0},
            options: [],
            pagamentos:[],
            item: {id: '', description: '' }
        }
    },
    methods:{
        generatePdf(){
            var nome_cli = localStorage.getItem('cliente_vinculado');
            nome_cli = JSON.parse(nome_cli);
            this.nome_cli = nome_cli.nome;
            var forma_pag = localStorage.getItem('forma_pagamento');
            forma_pag = JSON.parse(forma_pag);
            this.pag_forma_desc = forma_pag.label;
            this.$refs.html2Pdf.generatePdf();
        },
        handleScroll(/*evt, el*/){
            if(window.scrollY > 336){
                this.exibirBotao = true;
            }else{
                this.exibirBotao = false;
            }
        },
        
        priceFormater(discountPrice){
            return discountPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },

        formatarDescricao(descricao){
            return descricao.substring(0,27)
        },

        Comentar(){
            axios.post(`${ baseApiUrl }/orders/order/`, this.order)
                .then(resp =>{
                    if(resp.data){
                        this.$awn.success('Observação adicionada')
                    }else{
                        this.$awn.warning('Erro ao adicionar Observação')
                    }
                })
                .finally();
        },

        remove(produto, index){
            axios.delete(`${ baseApiUrl }/orders/${ produto.id }`)
                .then(() => {
                    this.produtos.splice(index,1)
                    this.TotalPedido();
               })
                .catch(error => this.$awn.warning(error))
                .finally(/*sempre executa*/)
        },
        carregaPagamentos(){
        axios.get(`${baseApiUrl}/payments/pagamentos/`)
        .then(res => {
            this.pagamentos = res.data;
            this.pagamentos.forEach(element => {
                this.options.push({'label': element.description , 'id': element.id, 'avista': element.inCash });
            });
            
        });            
        },
        ordernarIndice(){
            /* order lista */
            this.ordenado = !this.ordenado;
            this.produtos.sort((a, b) =>{
                if(!this.ordenado){
                    return a.productId.localeCompare(b.productId);
                }
                return b.productId.localeCompare(a.productId);
            })
        },

        TotalPedido(){
            this.total = 0;
            this.total_sugerido = 0;
            this.qtd_total = 0;
            this.produtos.forEach(produto => {
                this.qtd_total += produto.quantity;
                if(produto.percentageDiscountVendedor != 0){
                    this.total += (produto.unitaryPrice - ( produto.unitaryPrice * produto.percentageDiscountVendedor) / 100) * produto.quantity ;
                    this.total_sugerido = this.total + this.total  * 0.15;
                    
                } else if (produto.percentageAdd != 0){
                    this.total += (produto.unitaryPrice + (produto.unitaryPrice * produto.percentageAdd) / 100 ) * produto.quantity;
                    this.total_sugerido = this.total+this.total  * 0.15;

                } else {
                    this.total += produto.quantity * produto.unitaryPrice;
                    this.total_sugerido = this.total+this.total  * 0.15;
                }
            });
            this.total_lojista = this.total;
        },
        Conclude(){
        axios.post(`${ baseApiUrl }/orders/conclude`+(this.cliente ? `/?clienteID=${this.cliente}&pagtoId=${this.pagtoId}` : `/?pagtoId=${this.pagtoId}`))
        .then(resp =>{
            if(resp.data.valid){
                this.$awn.success(resp.data.message, {labels: {success: resp.data.title }})
            }else{
                this.$awn.warning(resp.data.message, {labels: {warning: resp.data.title }})
            }
        })
        // .catch(error)
        .finally(this.$router.push({ path: '/' }));
        },
        
        SetPagamento (pagamento)
        {
            const id =(pagamento == null ? 0 : pagamento.id);
            this.pagamento = id;
            localStorage.setItem('forma_pagamento', JSON.stringify({"id":id, "label":pagamento.label, "avista":pagamento.avista}));
            this.percent = (pagamento.avista == "S" ? 6 : 3 );
            this.pagtoId = pagamento.id;
            this.forma_pagamento_alterado = pagamento.label;
            alert('Forma de pagamento alterada.');
            // window.location.reload();
            // window.location.replace('/pedido');


        },
        
        EnviarPedido()
        {
            if(this.cliente != 0){
                axios.post(`${ baseApiUrl }/orders/conclude/`)
                .then(resp =>{
                    if(resp.data.valid){
                        this.$awn.success(resp.data.message, {labels: {success: resp.data.title }})
                    }else{
                        this.$awn.warning(resp.data.message, {labels: {warning: resp.data.title }})
                    }
                })
                .finally(this.$router.push({ path: '/' }));
            } else {
                alert('Selecione um cliente por favor.');
            }
        }
    },
    
    created(){
        const json = localStorage.getItem(userKey);
        const userData = JSON.parse(json);

        if(userData.tipoAcesso=="V"){
            this.vendedorID = userData.vendedor;
            this.vendedor = true;
            this.carregaPagamentos();
            const obj = JSON.parse(localStorage.getItem('cliente_vinculado'));
            this.cliente = obj.id;
            const pagto= JSON.parse(localStorage.getItem('forma_pagamento'));
            this.pagtoId = pagto.id;
            this.percent = (pagto.avista == "S" ? 6 : 3 );
            this.selected = {label:pagto.label, id:pagto.id};
            
        }
    },
    directives: {
        scroll: {
            inserted: function (el, binding) {
                let f = function (evt) {
                if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f)
                }
                }
                window.addEventListener('scroll', f)
            }
        }
    }
}
</script>

<style scoped>
.div-pdf {
    width: 100%;
    text-align: center;
    margin-top: 50px;
}
.div-pdf table th, .div-pdf table td {
    text-align: left;
}
.esconder{
    display: none;
}

table {
    border: 1px solid #ccc;
    width: 100%;
    margin:0;
    padding:0;
    border-collapse: collapse;
    border-spacing: 0;
  }

  table tr {
    border: 1px solid #ddd;
    padding: 5px;
    background: #fff;

  }

  table th, table td {
    padding: 10px 5px 10px 5px;
  }

  table tr th{text-align: left;}

  table th {
    text-transform: uppercase;
    letter-spacing: 1px;
    height: 50px;
  }

    .acoes{
        text-transform: uppercase;
        cursor:pointer;
        font-size: 20px;
    }

  @media screen and (max-width: 600px) {
      .p-quantity{
          margin-right: 2px;
            margin-left: auto;
        }
   #card{
       width: 100%;
   }   
   #card table {
      border: 0;
    }

   #card table thead {
      display: none;
    }

   #card table tr {
        margin-bottom: 20px;
        display: block;
        border-bottom: 2px solid #ddd;
        box-shadow: 2px 2px 1px #dadada;
    }

   #card table td {
      display: block;
      text-align: right;
      font-size: 13px;
      max-width: 400px;
      width: 100%;
    }

   #card table td:last-child {
      border-bottom: 0;
    }

   #card table td::before {
      content: attr(data-label);
      float: left;
      text-transform: uppercase;
      font-weight: bold;
    }

    td:nth-child(even) {
        background-color: #f2f2f2
    }

    /* .quantidade{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-grow: 2;
    } */

    td [data-label="Quantidade"]{
        background-color: red;
    }
  }
@media screen and (min-width: 600px) {
    tr:nth-child(2n+2) {
    background: #f8f8f8;
    }
    #card{
        width: 100%;
        overflow: auto;
    }
}


/* remover botoes padrao input number */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}




/*
animacao remocao tabela.
*/

/* @keyframes slide-in {
    from { transform: translateX(40px) }
    to { transform: translateY(0) }
}

@keyframes slide-out {
    from { transform: translateY(0) }
    to { transform: translateY(40px) }
} */


@keyframes slide-in {
    from { transform: translateX(-160px); }
    to { transform: translateY(0) }
}

@keyframes slide-out {
    from { transform: translateY(0) }
    to { transform: translateX(-160px); }
}


.slide-enter-active{
    animation: slide-in 0.5s ease;
	transition: opacity 0.5s;
}

.slide-leave-active {
    animation: slide-out 0.5s ease;
    transition: opacity 0.5s;
}

.slide-enter, .slide-leave-to{
    opacity: 0;
}
.slide-move{
	transition: transform 0.5s;
}
</style>
